import ImgHourglass from "@simble/shared/assets/images/hourglass.png";
import Button from "@simble/ui/button";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Header from "@/components/header";
import PageLayout from "@/layouts/page-layout";

export const Route = createFileRoute("/invalid-token")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  const handleGoToFinuslugi = () => {
    navigate({ href: "https://agents.finuslugi.ru/app/instrumenty_zarabotka" });
  };

  return (
    <PageLayout className="flex h-full flex-col items-center justify-center" header={<Header isDisabledClick={true} />}>
      <div className="mt-[52px] mb-[60px] flex h-full flex-col items-center justify-center space-y-4 p-5 px-0 md:mt-[108px] md:mb-[120px] md:px-5">
        <img alt="" height={160} src={ImgHourglass} width={160} />
        <h5 className="headline5 text-center">Срок действия ссылки истёк</h5>
        <div className="body-regular text-center">
          Пожалуйста, вернитесь на сайт Финуслуг и перейдите <br /> к оформлению заново
        </div>
        <Button className="w-full font-normal" onClick={handleGoToFinuslugi}>
          Вернуться на Финуслуги
        </Button>
      </div>
    </PageLayout>
  );
}
